import axios from 'axios';
import type { User } from './auth';
import { API_BASE_URL, type ApiResponse } from './client';

export interface ImpersonationExchangeResult {
  accessToken: string;
  /** ISO timestamp; the token has no refresh and stops working then. */
  expiresAt: string;
  /** The target account (never carries a password hash). */
  user: User;
}

/**
 * Trades a one-time impersonation code for an access token of the target
 * account.
 *
 * Deliberately a plain axios call, not `apiClient`: the exchange page runs
 * in a tab that is not marked yet, where `apiClient` would attach the
 * admin's token from localStorage and its 401 interceptor would refresh or
 * drop the admin's session. The API answers every refusal with 400
 * (`impersonation_code_invalid`), never 401.
 */
export async function exchangeImpersonationCode(
  code: string
): Promise<ImpersonationExchangeResult> {
  const response = await axios.post<ApiResponse<ImpersonationExchangeResult>>(
    `${API_BASE_URL}/auth/impersonation/exchange`,
    { code },
    { headers: { 'Content-Type': 'application/json' }, timeout: 30000 }
  );
  return response.data.data;
}
